// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__32Udp","selects":"Documents_selects__3Lrfw"};